import { ConcreteEncodable } from "./ConcreteEncodable";

import { BaseUserTokenEncoder } from "../../encoder/BaseUserTokenEncoder";

import * as CubiqTS from "../../index";

export class BaseUserToken extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.security.BaseUserToken";

  /*FID=1*/
  public userName: string;
  /*FID=2*/
  public password: string;
  /*FID=3*/
  public timeStamp: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = BaseUserTokenEncoder.Instance;
    this.setEncodableType(BaseUserToken.enType);
    //Model
  }

  public toString(): string {
    return (
      "BaseUserToken[" +
      "userName=" +
      this.userName +
      "password=" +
      this.password +
      "timeStamp=" +
      this.timeStamp +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
